<div class="container-fluid">
    <mat-radio-group [(ngModel)]="value" (change)="onClick($event.value)">
        <mat-radio-button class="d-block" [disabled]="summaryMode" [value]="true"
            [attr.data-test-value]="true">Yes</mat-radio-button>
        <mat-radio-button class="d-block" [disabled]="summaryMode" [value]="false"
            [attr.data-test-value]="false">No</mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="question.invalid">required</mat-error>
</div>